import { useRest } from "../common/rest"

export function useGood(type, unitId) {
    const [good, reload] = useRest('transaction/good/' + type + '' + (unitId ? "?unitId=" + unitId : ''))


    return {
        ...good,
        loading: !good,
    }
}
